
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Comparison = lazy(() => import('../pages/comparison/page'));
const BlogList = lazy(() => import('../pages/blog-list/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogBluebeamTakeoffs = lazy(() => import('../pages/blog-bluebeam-takeoffs/page'));
const BlogComplexLayouts = lazy(() => import('../pages/blog-complex-layouts/page'));
const BlogLifecycle = lazy(() => import('../pages/blog-lifecycle/page'));
const BlogSlopedSites = lazy(() => import('../pages/blog-sloped-sites/page'));
const BlogSpeedTimelines = lazy(() => import('../pages/blog-speed-timelines/page'));
const BlogEmployeeVsContractor = lazy(() => import('../pages/blog-employee-vs-contractor/page'));
const BlogSurgeCapacity = lazy(() => import('../pages/blog-surge-capacity/page'));
const BlogExpertVsGeneralist = lazy(() => import('../pages/blog-expert-vs-generalist/page'));
const BlogRentalHousing = lazy(() => import('../pages/blog-rental-housing/page'));
const BlogSoftwareCosts = lazy(() => import('../pages/blog-software-costs/page'));
const BlogTechnicalBottleneck = lazy(() => import('../pages/blog-technical-bottleneck/page'));
const FAQ = lazy(() => import('../pages/faq/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/comparison',
    element: <Comparison />,
  },
  {
    path: '/knowledge-hub',
    element: <BlogList />,
  },
  {
    path: '/blog-list',
    element: <BlogList />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog-bluebeam-takeoffs',
    element: <BlogBluebeamTakeoffs />,
  },
  {
    path: '/blog-complex-layouts',
    element: <BlogComplexLayouts />,
  },
  {
    path: '/blog-lifecycle',
    element: <BlogLifecycle />,
  },
  {
    path: '/blog-sloped-sites',
    element: <BlogSlopedSites />,
  },
  {
    path: '/blog-speed-timelines',
    element: <BlogSpeedTimelines />,
  },
  {
    path: '/blog-employee-vs-contractor',
    element: <BlogEmployeeVsContractor />,
  },
  {
    path: '/blog-surge-capacity',
    element: <BlogSurgeCapacity />,
  },
  {
    path: '/blog-expert-vs-generalist',
    element: <BlogExpertVsGeneralist />,
  },
  {
    path: '/blog-rental-housing',
    element: <BlogRentalHousing />,
  },
  {
    path: '/blog-software-costs',
    element: <BlogSoftwareCosts />,
  },
  {
    path: '/blog-technical-bottleneck',
    element: <BlogTechnicalBottleneck />,
  },
  {
    path: '/areas-we-serve',
    element: <FAQ />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
